import React, { useState, useEffect, useRef } from "react";

import PropTypes from "prop-types";
import { Tabs, Tab, Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

import workSpaceCss from "../../css/workSpaceOverView.module.css";
import sidemenucss from "../../css/sidemenu.module.css";

import Modal from "../../elements/Modal";
import modalcss from "../../css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as LRRPTIcon } from "../../assets/icons/LRRPT.svg";
import buttoncss from "../../css/button.module.css";
import { Button } from "../../elements/Button";
import { set } from "react-hook-form";
import swal from "sweetalert";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import { ReactComponent as PlusIcon } from "../../assets/icons/plusprimary.svg";
import AddRPTTransactionModal from "../../../WorkSpace/Components/Modal/AddRPTTransactionModal";


const ViewRPTTransactions = ({ children, apiResponseData, getPopulateFSNotes, notesData, tableTitle }) => {
  const [rptList, setRPTList] = useState([1]);
  const [showAddRPTTransactionModal, setShowAddRPTTransactionModal] = useState(false);

  console.log("apiResponseData", apiResponseData);
  console.log("notesData", notesData);
  
  return (
    <>
    <div style={{ backgroundColor: "#ffffff", border: "1px solid #EAEEED", borderRadius: "20px",  width: "100%", marginTop: "20px" , padding: "20px 0"}} >
      <div className="" style={{ fontWeight: 400, fontSize: "20px", lineHeight: "100%", letterSpacing: "0px", borderRadius: "20px 20px 0px 00px", display: "flex", justifyContent: "space-between", padding: " 0 18px" }}>
        <span className=" text-capitalize m-0 p-2 pb-0" >Related Parties</span>
        <span className={commoncss.dFlex}>
          <button
         
            onClick={() => setShowAddRPTTransactionModal(true)}
            style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "18px", padding: "10px 12px", background: "#ffffff", border: "1px solid #7ECEA7", fontColor: "#1A4338",
              cursor: "pointer", borderRadius: "10px", marginTop: "2px" }}>
            <PlusIcon width={20} height={20} />
            Add
          </button>
        </span>
      </div>
        <div style={{ padding: "20px" }}>
          {children}
        </div>
      </div>
      {/* <div style={{ "height": "88vh", "overflow": "auto" }}>
        <>
          <div className="d-flex py-2 ">
            <div className="ml-2 mr-2" style={{ backgroundColor: "#ffffff", border: "1px solid #EAEEED", borderRadius: "20px", width: "100%" }}>
              <div className="" style={{ fontWeight: 400, fontSize: "20px", lineHeight: "100%", letterSpacing: "0px", borderBottom: "1px solid #EAEEED", borderRadius: "20px 20px 0px 00px", display: "flex", justifyContent: "space-between" }}>
                <span className=" text-capitalize m-0 p-3" >Related Parties</span>
                <span className={`${commoncss.dFlex} pr-2`}><Button
                  btnColor={buttoncss.secondary}
                  icon={<PlusIcon />}
                  label="Add"
                  onClick={setShowAddRPTTransactionModal}
                />
                </span>
              </div>
              <div className="px-3" style={{ border: "0px solid #EAEEED", borderRadius: "0px", height: "75vh", overflow: "auto" }}>
              </div>

            </div>
          </div>
        </>
      </div> */}
      {showAddRPTTransactionModal && (
        <AddRPTTransactionModal setShowAddRPTTransactionModal={setShowAddRPTTransactionModal} />
      )}
    </>
  );
};

export default ViewRPTTransactions;
